type Props = {
    sectionId: string;
};

function ScrollToTop({ sectionId }: Props) {
    const handleScrollToSection = (sectionId: string) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <button
            className='scrollButton'
            onClick={() => handleScrollToSection(sectionId)}
        >
            <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6 '
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
            >
                <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M5 15l7-7 7 7'
                />
            </svg>
            <p className='text-page-light text-page-light--blueSmall'>Haut de page</p>
        </button>
    );
}

export default ScrollToTop;
